<div class="content-container" [tslSpinner]="isRedirecting">
  <div class="interstital-content">
    <h1 class="tds-text--h1-alt" i18n="@@MFAEnrollment" t="MFAEnrollment">Multi-Factor Authentication Enrollment</h1>
    <p class="instructions" i18n="@@MFAInstructions" t="MFAInstructions">
      Multi-factor authentication (MFA) protects your Tesla account by requiring a secondary form of verification before signing in. 
      Please enroll in Multi-factor authentication in order to access your Tesla Supplier Profile. 
      Once fully set-up, you'll be required to enter your account credentials and verify their identity from a registered device each time you sign into an application of the Supplier Relationship Management Portal. 
      After enrollment, please log out of your account and back in to access your Tesla Supplier Profile.
    </p>
    <div class="mfa-icon-container">
      <div class="mfa-icon" dir="ltr">
        <svg width="108px" height="142px" viewBox="0 0 108 142" version="1.1">
          <title>MFA Icon</title>
          <desc>Phone with Passcode.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="INTERSTITIAL_DESKTOP" transform="translate(-664.000000, -432.000000)">
              <g id="content" transform="translate(445.000000, 116.000000)">
                <g id="mfa-icon" transform="translate(222.000000, 316.000000)">
                  <path
                    d="M86,79.999 L86,131.573034 C86,137.095881 81.5228475,141.573034 76,141.573034 L26,141.573034 C20.4771525,141.573034 16,137.095881 16,131.573034 L16,79.999 L19.932,79.999 L19.9325843,130.561798 C19.9325843,134.391445 22.9737686,137.510785 26.7728285,137.63651 L27.011236,137.640449 L74.988764,137.640449 C78.8981954,137.640449 82.0674157,134.471229 82.0674157,130.561798 L82.0674157,130.561798 L82.067,79.999 L86,79.999 Z M76,2.27373675e-13 C81.5228475,2.21453871e-13 86,4.4771525 86,10 L86,37.999 L82.067,37.999 L82.0674157,11.011236 C82.0674157,7.18158889 79.0262314,4.06224849 75.2271715,3.9365235 L74.988764,3.93258427 L68.9101124,3.93258427 C68.3578276,3.93258427 67.9101124,4.38029952 67.9101124,4.93258427 L67.9101124,4.93258427 L67.9101124,6.29213483 L67.9062621,6.44915533 C67.8244441,8.11373266 66.4489177,9.43820225 64.7640449,9.43820225 L64.7640449,9.43820225 L37.2359551,9.43820225 L37.0789346,9.43435201 C35.4143572,9.35253395 34.0898876,7.97700761 34.0898876,6.29213483 L34.0898876,6.29213483 L34.0898876,4.93258427 C34.0898876,4.38029952 33.6421724,3.93258427 33.0898876,3.93258427 L33.0898876,3.93258427 L27.011236,3.93258427 C23.1018046,3.93258427 19.9325843,7.10180458 19.9325843,11.011236 L19.9325843,11.011236 L19.932,37.999 L16,37.999 L16,10 C16,4.4771525 20.4771525,2.28388206e-13 26,2.27373675e-13 L76,2.27373675e-13 Z"
                    id="Combined-Shape"
                    fill="#171A20"
                  ></path>
                  <rect
                    id="Rectangle"
                    stroke="#3368FF"
                    stroke-width="3"
                    fill-opacity="0.08"
                    fill="#3368FF"
                    x="-1.5"
                    y="42.5"
                    width="105"
                    height="33"
                    rx="5"
                  ></rect>
                  <text id="123-456" font-family="Helvetica" font-size="16" font-weight="bold" letter-spacing="-0.32" fill="#3E6AE1">
                    <tspan x="22" y="65">123 456</tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="action-container">
        <button (click)="onEnroll()" tsl-button color="blue" filled size="medium" i18n="@@Enroll" t="Enroll">Enroll</button>
    </div>
  </div>
</div>
